const technicalQuestions = {
    productDesign: [
      { question: "How would you design a product to help remote teams collaborate more effectively?" },
      { question: "What features would you prioritize for a new social media platform?" },
      { question: "How would you improve the user experience of an existing e-commerce website?" }
    ],
    marketSizing: [
      { question: "Estimate the market size for electric scooters in a major city." },
      { question: "How would you determine the potential market size for a new fitness app?" },
      { question: "Estimate the number of coffee shops in the United States." }
    ],
    metrics: [
      { question: "What metrics would you use to measure the success of a new feature on a mobile app?" },
      { question: "How would you track user engagement on a content platform?" },
      { question: "What key performance indicators (KPIs) would you monitor for an online marketplace?" }
    ]
  };
  
  export default technicalQuestions;